module.exports = __webpack_public_path__ + "static/media/wolf-row.d10d31e2.png";